// extracted by mini-css-extract-plugin
export var attachmentContainer = "_lk-0";
export var fileList = "_lk-2";
export var removeFileButton = "_lk-1";